import React from "react";
import { elementTitles, TWebsiteBuilderElementType } from "../../../../nodes/element/websiteBuilderElement";
import { IWebsiteBuilderElementViewBoundingBox } from "./WebsiteBuilderElementView";
import { websiteBuilderZLayers } from "../../../../websiteBuilderZLayers";

interface IElementHoverTitleProps {
  hoveredNotSelected: boolean;
  boundingBox: IWebsiteBuilderElementViewBoundingBox;
  type: TWebsiteBuilderElementType;
}

const TITLE_CONTAINER_HEIGHT = 20;
const TITLE_CONTAINER_OFFSET = 1;

export function ElementHoverTitle(props: IElementHoverTitleProps) {
  const { hoveredNotSelected, boundingBox, type } = props;

  const spaceOnTop = boundingBox.y > TITLE_CONTAINER_HEIGHT + TITLE_CONTAINER_OFFSET;

  return (
    <>
      {hoveredNotSelected && (
        <div
          className="website-builder-element-hover-title-container"
          style={{
            left: boundingBox.x - TITLE_CONTAINER_OFFSET,
            top: spaceOnTop
              ? boundingBox.y - TITLE_CONTAINER_HEIGHT - TITLE_CONTAINER_OFFSET
              : boundingBox.y + boundingBox.height + TITLE_CONTAINER_OFFSET,
            height: TITLE_CONTAINER_HEIGHT,
            borderRadius: spaceOnTop ? "5px 5px 0 0" : "0 0 5px 5px",
            zIndex: websiteBuilderZLayers.designSpace.elementOverride,
          }}
        >
          <div className="element-hover-title-positioner">
            <div className="element-hover-title">{elementTitles[type]}</div>
          </div>
        </div>
      )}
    </>
  );
}
